import { render } from "./ReservationsToolbar.vue?vue&type=template&id=4b4eb7b0&scoped=true"
const script = {}

import "./ReservationsToolbar.vue?vue&type=style&index=0&id=4b4eb7b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4eb7b0"]])

export default __exports__